var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8SouthSudan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#388e3c",
    d: "M41.302,34H10.004L7.67,35.522C11.291,40.645,17.249,44,24,44C31.398,44,37.843,39.972,41.302,34z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#d50000",
    d: "M25.333,24.005L14.605,31h28.11C43.532,28.818,44,26.467,44,24s-0.468-4.818-1.284-7H14.595 L25.333,24.005z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "M41.303,14C37.843,8.028,31.398,4,24,4c-6.753,0-12.711,3.356-16.332,8.481L9.996,14H41.303z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M14.595,17h28.121c-0.391-1.044-0.861-2.047-1.413-3H9.996L14.595,17z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M10.004,34h31.299c0.552-0.953,1.022-1.956,1.413-3h-28.11L10.004,34z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#3f51b5",
    d: "M14.605,31l10.728-6.995L14.595,17l-4.599-3l-2.328-1.519C5.365,15.739,4,19.707,4,24 c0,4.294,1.366,8.263,3.67,11.522L10.004,34L14.605,31z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffeb3b",
    d: "M13.387,24.137l2.082-2.781l-3.371,1.055l-2.09-2.793l0.008,3.445l-3.371,1.059l3.375,1.074 l0.004,3.445l2.078-2.785l3.375,1.074L13.387,24.137z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8SouthSudan);
export default __webpack_public_path__ + "static/media/icons8-south-sudan.c991e0fefb8bad4aaca4e735139c34f2.svg";
export { ForwardRef as ReactComponent };